import _defineProperty from "/home/runner/work/jfssvex.github.io/jfssvex.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/jfssvex.github.io/jfssvex.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var oppositeDirections = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
export var getOppositePosition = function getOppositePosition(position) {
  return oppositeDirections[position];
};

var splitPlacement = function splitPlacement(placement) {
  return placement.split("-");
};

export function getArrowStyles(placement, arrowSize, arrowShadowColor) {
  var _ref;

  if (typeof placement !== "string") return {};

  var _splitPlacement = splitPlacement(placement),
      _splitPlacement2 = _slicedToArray(_splitPlacement, 1),
      position = _splitPlacement2[0];

  var oppositePosition = getOppositePosition(position);
  if (!oppositePosition) return {};
  return _ref = {}, _defineProperty(_ref, oppositePosition, "-" + arrowSize / 2 + "px"), _defineProperty(_ref, "width", arrowSize), _defineProperty(_ref, "height", arrowSize), _defineProperty(_ref, "position", "absolute"), _defineProperty(_ref, "transform", "rotate(45deg)"), _defineProperty(_ref, "boxShadow", arrowShadowColor ? getBoxShadow(placement, arrowShadowColor) : undefined), _ref;
}
export function getBoxShadow(placement, color) {
  if (placement.includes("top")) {
    return "2px 2px 2px 0 " + color;
  }

  if (placement.includes("bottom")) {
    return "-1px -1px 1px 0 " + color;
  }

  if (placement.includes("right")) {
    return "-1px 1px 1px 0 " + color;
  }

  if (placement.includes("left")) {
    return "1px -1px 1px 0 " + color;
  }
}
var transformEnum = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
};
export var toTransformOrigin = function toTransformOrigin(placement) {
  return transformEnum[placement];
};